export const validatePassword = (password: string, confirmedPassword: string) => {
    // let regExpWeak = /[a-z]/;
    // let regExpMedium = /\d+/;
    // let regExpStrong = /.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/;
    // let inputWeek = password.match(regExpWeak);
    // let inputMedium = password.match(regExpMedium);
    // let inputStrong = password.match(regExpStrong);

    const condition1 = password === confirmedPassword;

    if (condition1) {
        return {
            isValid: true,
            securityLevel: 'strong',
            msg: 'Password Strong.',
        };
    } else {
        return {
            isValid: false,
            securityLevel: 'not valid',
            msg: 'Passwords must match',
        };
    }
};

export const validateEmail = (email: string) => {
    let validation = { isValid: false, message: '' };

    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (email.match(validRegex)) {
        validation.message = 'Valid email address!';
        validation.isValid = true;
    } else {
        validation.message = 'Please provide a properly formatted e-mail address';
        validation.isValid = false;
    }

    return validation;
};
